module.exports = __webpack_public_path__ + "static/media/home-bg-8.a673391c.jpg";